module.exports = __webpack_public_path__ + "img/ic-edit.65a4f42f.svg";